<template>
  <div class="navbar-container main-menu-content w-100">
    <horizontal-nav-menu-items
      :items="navMenuItems"
      class="flex-nowrap w-100"
      v-on:update-group-open="onUpdateGroupOpen"
    />
  </div>
</template>

<script>
import navMenuItems from '@/navigation/horizontal'
import HorizontalNavMenuItems
  from '@/core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

export default {
  components: { HorizontalNavMenuItems },
  setup(props, { emit }) {
    const onUpdateGroupOpen = (event) => {
      emit('update-group-open', event)
    }

    return {
      navMenuItems,
      onUpdateGroupOpen
    }
  },
}
</script>

<style lang='scss'>
@import '@/core/scss/base/core/menu/menu-types/horizontal-menu.scss';
@import '@/assets/scss/style';
.flex-nowrap {
  position: absolute;
  .nav-item {
    background-color: $body-bg;
  }
  background-color: $body-bg;
}

.dark-layout {
  .flex-nowrap {
    .nav-item {
      background-color: $theme-dark-card-bg;
    }
    background-color: $theme-dark-card-bg;
  }
}
</style>
